import React from "react";
import { Bar } from "react-chartjs-2";
import "./style.css";

const StackedBarChart = ({ chartData, title }) => {
  return (
    <div className="chart-container">
      <Bar
        datasetIdKey="id"
        data={chartData}
        options={{
          plugins: {
            title: {
              display: true,
              text: title,
            },
            legend: {
              display: true,
            },
          },
          barThickness: 15,
          scales: {
            x: {
              stacked: true,
              ticks: {
                maxRotation: 90,
                minRotation: 90,
              },
            },
            y: {
              stacked: true,
            },
          },
        }}
      />
    </div>
  );
};
export default StackedBarChart;
